import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00c21995"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-info"
};
const _hoisted_2 = {
  class: "user-info-wrap"
};
const _hoisted_3 = {
  class: "user-info-left"
};
const _hoisted_4 = {
  class: "user-info-name"
};
const _hoisted_5 = {
  class: "user-info-real"
};
const _hoisted_6 = {
  class: "user-info-mobile"
};
import { useUserStore } from '@/stores/user';
export default {
  __name: 'index',
  setup(__props) {
    const {
      userInfo
    } = useUserStore();
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
        size: 75,
        src: "http://static-cdn.glodonedu.com/student_platform/icon/avatar.png"
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(userInfo).fullname || '未知'), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(userInfo).mobile), 1)])])])]);
    };
  }
};